module.exports = __webpack_public_path__ + "img/cool.ab7302db.png";